/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Avatar from 'components/Avatar.jsx';
import Group from 'entities/Group';
import Organization from 'entities/Organization';

import './styles/GroupAvatar.scss';
import type { RosterGroupSummary } from 'setup/components/SetupRosterConfirm.jsx';

type Props = {
  group: Group | Organization | RosterGroupSummary | { groupAvatar: { svg_url: string } },
  size?: 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large',
  className?: string,
};

class GroupAvatar extends React.Component<Props> {
  render() {
    const { className, group, size, ...others } = this.props;

    let url = null;

    if (group.groupAvatar) {
      url = group.groupAvatar.svg_url;
    } else if (group.getAvatarUrl) {
      url = group.getAvatarUrl();
    }

    if (!url) {
      return null;
    }

    return (
      <Avatar
        {...others}
        className={cx('GroupAvatar', size && `GroupAvatar--${size}`, className)}
        image={url}
      />
    );
  }
}

export default GroupAvatar;
